// Unit types and their properties
export const UNIT_TYPES = {
    COCONUT_CLUBBER: { name: 'Coconut Clubber', health: 1, attack: 1, moveRange: 1, attackRange: 1, sightRange: 2, canClearBushes: false, icon: '🏏' },
    BUSHWHACKER: { name: 'Bushwhacker', health: 1, attack: 2, moveRange: 1, attackRange: 1, sightRange: 2, canClearBushes: true, icon: '🪓' },
    COCONUT_THROWER: { name: 'Coconut Thrower', health: 1, attack: 1, moveRange: 1, attackRange: 2, sightRange: 2, canClearBushes: false, icon: '🥥' },
    EXPLODING_COCONUT_RUNNER: { name: 'Exploding Runner', health: 1, attack: 0, moveRange: 4, attackRange: 0, sightRange: 2, canClearBushes: false, icon: '💥' },
    COCONUT_BOMBER: { name: 'Coconut Bomber', health: 5, attack: 0, moveRange: 2, attackRange: 1, sightRange: 0, canClearBushes: false, icon: '🎈', maxLifespan: 10 }, // Base sight 0, calculated dynamically
    BANANA_TREE: { name: 'Sacred Banana Tree', health: 200, attack: 0, defense: 20, moveRange: 0, attackRange: 0, sightRange: 1, canClearBushes: false, icon: '🍌' },
    IDOL_STONE: { name: 'Idol Stone', health: 9999, attack: 0, defense: 9999, moveRange: 0, attackRange: 0, sightRange: 0, canClearBushes: false, icon: '🏛️' }
};

// Color constants
export const COLOR_BUSH = '#4ade80';         // Green for uncleared bushes
export const COLOR_IDOL_GOLD = '#FFD700';    // Gold for surrounding idol stones
export const COLOR_DEFAULT_HEX = '#D2B48C'; // Light brown for default ground
export const COLOR_ATTACK = '#fca5a5';       // Red highlight for attack targets
export const COLOR_SELECTED = '#90cdf4';     // Blue highlight for selected unit
export const COLOR_MOVE = '#fed7aa';         // Tan highlight for possible moves
export const COLOR_FOG = '#a0aec0';          // Grey for unseen hexes (optional addition)
export const COLOR_IDOL_CENTER = '#A9A9A9'; // 

// Grid dimensions
export const GRID_WIDTH = 21;
export const GRID_HEIGHT = 13;
export const HEX_SIZE = 25; // pixels

// Derived geometry (can be calculated here or in components needing it)
export const HEX_WIDTH = HEX_SIZE * 2;
export const HEX_HEIGHT = Math.sqrt(3) * HEX_SIZE;
export const SVG_WIDTH = GRID_WIDTH * HEX_WIDTH * 0.75 + HEX_WIDTH * 0.25;
export const SVG_HEIGHT = GRID_HEIGHT * HEX_HEIGHT + HEX_HEIGHT * 0.5;
export const CENTER_COL = Math.floor(GRID_WIDTH / 2);
export const CENTER_ROW = Math.floor(GRID_HEIGHT / 2);
export const CENTER_HEX_ID = `${CENTER_COL},${CENTER_ROW}`;

// Game Owners
export const OWNER_PLAYER = 'PLAYER';
export const OWNER_COMPUTER = 'COMPUTER';
export const OWNER_NATURE = 'NATURE';

// Game Status
export const STATUS_PLAYING = 'PLAYING';
export const STATUS_PLAYER_WON = 'PLAYER_WON';
export const STATUS_COMPUTER_WON = 'COMPUTER_WON';

// Action Types (for AI or potential reducer)
export const ACTION_MOVE = 'MOVE';
export const ACTION_ATTACK = 'ATTACK';

// Misc
export const EXPLOSION_DURATION = 2000; // ms
export const AI_THINKING_TIME = 1000; // ms
export const POST_AI_ACTION_DELAY = 750; // ms
export const POST_AI_NO_ACTION_DELAY = 250; // ms